module.exports = __webpack_public_path__ + "img/7.93fa94d6.png";